import "./styles/main.scss";
import React, { useState } from "react";
import { useLocation, Route, Routes } from "react-router-dom";
import UserContext from "./context/UserContext";
import { CompaniesProvider } from "./context/CompanyContext";

import NavigationBar from "./components/NavigationBar/NavigationBar";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

// LOGIN RELATED IMPORTS
import LoginPage from "./components/LoginPage/LoginPage";
import NotImplementedPage from "./components/NotImplementedPage/NotImplementedPage";
import ForgotPasswordPage from "./components/LoginPage/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "./components/LoginPage/ResetPasswordPage/ResetPasswordPage";
import TotpVerificationPage from "./components/LoginPage/2FARelated/TotpVerificationPage";
// DASHBOARD RELATED IMPORTS
import DashboardPage from "./components/DashboardPage/DashboardPage";
// REPORTS RELATED IMPORTS
import ReportsPage from "./components/ReportsPage/ReportsPage";
// LOCATION RELATED IMPORTS
import LocationsPage from "./components/LocationsPage/LocationsPage";
import ContainerMoreInfoPage from "./components/LocationsPage/ContainerMoreInfoPage/ContainerMoreInfoPage";
// DEVICE RELATED IMPORTS
import DevicesPage from "./components/DevicesPage/DevicesPage";
import DeviceMoreInfoPage from "./components/DevicesPage/DeviceMoreInfoPage/DeviceMoreInfoPage";
// CROP RELATED IMPORTS
import CropsPage from "./components/CropsPage/CropsPage";
// SETTINGS RELATED IMPORTS
import SettingsPage from "./components/SettingsPage/SettingsPage";
import UserSettingsPage from "./components/SettingsPage/UserSettingsPage/UserSettingsPage";
import CompanySettingsPage from "./components/SettingsPage/CompanySettingsPage/CompanySettingsPage";
import CompanyEditUserPage from "./components/SettingsPage/CompanySettingsPage/CompanyEditUserPage/CompanyEditUserPage";
import CompanyEditLocationPage from "./components/SettingsPage/CompanySettingsPage/CompanyEditLocationPage/CompanyEditLocationPage";
import CompanyEditCompanyPage from "./components/SettingsPage/CompanySettingsPage/CompanyEditCompanyPage/CompanyEditCompanyPage";
// ALERT RELATED IMPORTS
import NotificationSettingsPage from "./components/SettingsPage/NotificationSettingsPage/NotificationSettingsPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductManagerPage from "./components/ProductManagerPage/ProductManagerPage";

function App() {
  const [user, setUser] = useState({
    token: localStorage.getItem("token"),
    userId: localStorage.getItem("userId"),
    roles: localStorage.getItem("roles"),
    lastname: localStorage.getItem("lastname"),
    firstname: localStorage.getItem("firstname"),
    company_id: localStorage.getItem("company_id"),
    companyname: localStorage.getItem("companyname"),
  });

  const location = useLocation();
  const isLoginPage = location.pathname === "/";
  const isForgotPasswordPage = location.pathname === "/forgot-password";
  const isResetPasswordPage = location.pathname.startsWith("/reset-password/");

  return (
    <CompaniesProvider>
      <UserContext.Provider value={{ user, setUser }}>
        {!isLoginPage && !isForgotPasswordPage && !isResetPasswordPage ? (
          <NavigationBar />
        ) : null}
        <Routes>
          {/* ----------- LOGIN RELATED ROUTES ----------- */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route
            path="/reset-password/:token"
            element={<ResetPasswordPage />}
          />
          <Route path="/verify-2fa" element={<TotpVerificationPage />} />

          {/* ----------- PROTECTED ROUTES ----------- */}
          {/* Dashboard */}
          {/* ----------- DASHBOARD RELATED ROUTES ----------- */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- REPORTS RELATED ROUTES ----------- */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- LOCATION RELATED ROUTES ----------- */}
          <Route
            path="/locations"
            element={
              <ProtectedRoute>
                <LocationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/company/sites/edit-location/:locationId"
            element={
              <ProtectedRoute>
                <CompanyEditLocationPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/locations/:containerId"
            element={
              <ProtectedRoute>
                <ContainerMoreInfoPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- DEVICE RELATED ROUTES ----------- */}
          <Route
            path="/devices"
            element={
              <ProtectedRoute>
                <DevicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId"
            element={
              <ProtectedRoute>
                <DeviceMoreInfoPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- CROP RELATED ROUTES ----------- */}
          <Route
            path="/crops"
            element={
              <ProtectedRoute>
                <CropsPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- SETTINGS RELATED ROUTES ----------- */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/user"
            element={
              <ProtectedRoute>
                <UserSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/company"
            element={
              <ProtectedRoute>
                <CompanySettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/company/edit-user/:userId"
            element={
              <ProtectedRoute>
                <CompanyEditUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/company/edit-location"
            element={
              <ProtectedRoute>
                <CompanyEditLocationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/company/edit-company/:companyId"
            element={
              <ProtectedRoute>
                <CompanyEditCompanyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/notifications"
            element={
              <ProtectedRoute>
                <NotificationSettingsPage />
              </ProtectedRoute>
            }
          />
          {/* ----------- ALERT RELATED ROUTES ----------- */}
          {/* ----------- PRODUCTMANAGER RELATED ROUTES ----------- */}
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <ProductManagerPage />
              </ProtectedRoute>
            }
          />

          {/* ----------- NOT IMPLEMENTED ROUTE ----------- */}
          <Route path="*" element={<NotImplementedPage />} />
        </Routes>
        <ToastContainer />
      </UserContext.Provider>
    </CompaniesProvider>
  );
}

export default App;
